import { useCallback } from 'react';

import { useAppContext } from '../../../store/App/utils/useAppContext';
import {
  resendUserMessage,
  sendMessageFail,
  sendUserMessage,
  updateChat,
} from '../../../store/transcript/actions';
import { useTranscriptContext } from '../../../store/transcript/utils/useTranscriptContext';

export const useSendMessage = () => {
  const { state, dispatch } = useTranscriptContext();
  const { endpoints } = useAppContext();

  /**
   * Send user message
   * @param message {string} - Message to send
   * @returns {Promise<void>} - No return. It dispatches action to update chat
   */
  const sendMessage = useCallback(
    async (message: string, messageId: string) => {
      dispatch(sendUserMessage({ message, messageId }));

      // Allow sending without sessionId - endpoint handles initialization
      endpoints
        .sendMessage(message, state.sessionId || '')
        .then((d) => {
          dispatch(updateChat(d));
        })
        .catch(() => {
          dispatch(sendMessageFail(messageId));
        });
    },
    [dispatch, endpoints, state.sessionId],
  );

  /**
   * Send user message
   * @param message {string} - Message to send
   * @returns {Promise<void>} - No return. It dispatches action to update chat
   */
  const resendMessage = useCallback(
    async (message: string, messageId: string) => {
      dispatch(resendUserMessage(messageId));

      if (!state.sessionId) {
        return Promise.reject('Session Id not found');
      }
      endpoints
        .sendMessage(message, state.sessionId)
        .then((d) => {
          dispatch(updateChat(d));
        })
        .catch(() => {
          dispatch(sendMessageFail(messageId));
        });
    },
    [dispatch, endpoints, state.sessionId],
  );

  return {
    sendMessage,
    resendMessage,
  };
};
